/**
 * Map loan type to text in PT (Portuguese)
 * @param type
 */
export function mapLoanTypeToText(type) {
    if (type === 'HOME_EQUITY') {
        return 'Empréstimo imobiliário';
    }
    if (type === 'CHEQUE_ESPECIAL') {
        return 'Cheque especial';
    }
    if (type === 'CAPITAL_GIRO_TETO_ROTATIVO') {
        return 'Capital de giro com teto rotativo';
    }
    if (type === 'CREDITO_PESSOAL_SEM_CONSIGNACAO') {
        return 'Crédito pessoal sem consignação';
    }
    if (type === 'CREDITO_PESSOAL_COM_CONSIGNACAO') {
        return 'Crédito pessoal com consignação';
    }
    if (type === 'MICROCREDITO_PRODUTIVO_ORIENTADO') {
        return 'Microcrédito produtivo orientado';
    }
    if (type === 'CAPITAL_GIRO_PRAZO_VENCIMENTO_ATE_365_DIAS') {
        return 'Capital de giro com prazo de vencimento até 365 dias';
    }
    if (type === 'CAPITAL_GIRO_PRAZO_VENCIMENTO_SUPERIOR_365_DIAS') {
        return 'Capital de giro com prazo de vencimento superior a 365 dias';
    }
    // OTHER
    return 'Outros';
}
